/**
 * @file Snackbar-related text
 */
import { __ } from '@@/bits/intl'

export const ACCESS_WITHDRAWN: { [key: string]: string } = {
  message: __('You are not authorized to access this padlet anymore.'),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export const SAVE_CHANGES_FAILED: { [key: string]: string } = {
  message: __("Sorry, we couldn't save your changes. Please refresh the page."),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export default {
  ACCESS_WITHDRAWN,
  SAVE_CHANGES_FAILED,
}
